import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ScrollProgress } from "@/components/ScrollProgress";
import { SmoothScroll } from "@/components/SmoothScroll";

interface LayoutWrapperProps {
  children: ReactNode;
}

// Routes that should NOT show the standard header/footer
const noLayoutRoutes = ["/new/", "/industries/aesthetics", "/quotes/"];

export function LayoutWrapper({ children }: LayoutWrapperProps) {
  const location = useLocation();
  
  // Check if current path matches any no-layout route pattern
  const shouldHideLayout = noLayoutRoutes.some(route => 
    location.pathname.startsWith(route)
  );

  if (shouldHideLayout) {
    return (
      <SmoothScroll>
        {children}
      </SmoothScroll>
    );
  }

  return (
    <SmoothScroll>
      <ScrollProgress />
      <Header />
      <main id="main-content" className="flex-grow">
        {children}
      </main>
      <Footer />
    </SmoothScroll>
  );
}
